export default {"src":"/_next/static/media/badge-experimental.b807ac3a.gif","height":75,"width":270};